import React from "react";

const sections = [
    {
        title: "Fixed Capital Investment (FCI)",
        desc:
            "FCI includes Land, Building, Plant & Machinery, Other Fixed Assets, Contingency, and Pre-operative expenses.",
    },


    {
        title: "Expansion/Diversification in MSMEs",
        desc:
            "Benefits except Employment Generation Subsidy shall be also be applicable to MSMEs undergoing 50% additional investment in plant and machinery for expansion/ diversification of existing unit with cap of 100% of new fixed capital investment on expanded FCI.",
    },

    {
        title: "Expansion/Diversification in Ultra Mega, Mega, Large Units",
        desc:
            "FoAn existing enterprise/ unit undertaking expansion/diversification at same location shall also be eligible to avail incentives under the policy in case of additional Fixed Capital Investment (FCI) of at least 50% of current FCI i.e. FCI as on date of commencement of expansion/ diversification. r existing MSME units, additional Plant & Machinery investment should be at least 50% of current Plant & Machinery. For Large/Mega units, additional FCI should be at least 50% of existing FCI.",
    },
];

export default function KnowledgePage() {
    return (
        <div className="max-w-5xl mx-auto p-6">
            <h1 className="text-4xl font-bold text-blue-900 mb-2">
                Input Guidelines
            </h1>

            <p className="text-gray-600 mb-8">
                Understand all calculation inputs and eligibility rules before
                generating incentive reports.
            </p>



            {/* ENTERPRISE TABLE */}
            <div className="mt-12">
                <h2 className="text-3xl font-bold text-blue-900 mb-5">
                    Enterprise Categorization
                </h2>

                <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm">
                    <table className="w-full text-sm text-left bg-white">
                        <thead className="bg-blue-900 text-white">
                            <tr>
                                <th className="p-4 border">Enterprise</th>
                                <th className="p-4 border">Block</th>
                                <th className="p-4 border">Investment Type</th>
                                <th className="p-4 border">Investment Limit (INR Cr.)</th>
                                <th className="p-4 border">Turnover Limit (INR Cr.)</th>
                            </tr>
                        </thead>

                        <tbody>

                            {/* ULTRA MEGA */}
                            <tr className="bg-blue-50">
                                <td className="p-4 border font-semibold">Ultra-Mega Project</td>
                                <td className="p-4 border">A</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 6000</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr>
                                <td className="p-4 border font-semibold">Ultra-Mega Project</td>
                                <td className="p-4 border">B</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 4500</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr className="bg-blue-50">
                                <td className="p-4 border font-semibold">Ultra-Mega Project</td>
                                <td className="p-4 border">C</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 3000</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr>
                                <td className="p-4 border font-semibold">Ultra-Mega Project</td>
                                <td className="p-4 border">D</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 1500</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            {/* MEGA */}
                            <tr className="bg-green-50">
                                <td className="p-4 border font-semibold">Mega Project</td>
                                <td className="p-4 border">A</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 500</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr>
                                <td className="p-4 border font-semibold">Mega Project</td>
                                <td className="p-4 border">B</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 400</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr className="bg-green-50">
                                <td className="p-4 border font-semibold">Mega Project</td>
                                <td className="p-4 border">C</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 300</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            <tr>
                                <td className="p-4 border font-semibold">Mega Project</td>
                                <td className="p-4 border">D</td>
                                <td className="p-4 border">Fixed Capital (FCI)</td>
                                <td className="p-4 border">&gt;= 200</td>
                                <td className="p-4 border">-</td>
                            </tr>

                            {/* LARGE */}
                            <tr className="bg-yellow-50">
                                <td className="p-4 border font-semibold">Large Enterprise</td>
                                <td className="p-4 border">-</td>
                                <td className="p-4 border">
                                    P&amp;M / Equipment OR Turnover
                                </td>
                                <td className="p-4 border">&gt; 125</td>
                                <td className="p-4 border">&gt; 500</td>
                            </tr>

                            {/* MEDIUM */}
                            <tr>
                                <td className="p-4 border font-semibold">Medium Enterprise</td>
                                <td className="p-4 border">-</td>
                                <td className="p-4 border">
                                    P&amp;M / Equipment AND Turnover
                                </td>
                                <td className="p-4 border">&lt;= 125</td>
                                <td className="p-4 border">&lt;= 500</td>
                            </tr>

                            {/* SMALL */}
                            <tr className="bg-orange-50">
                                <td className="p-4 border font-semibold">Small Enterprise</td>
                                <td className="p-4 border">-</td>
                                <td className="p-4 border">
                                    P&amp;M / Equipment AND Turnover
                                </td>
                                <td className="p-4 border">&lt;= 25</td>
                                <td className="p-4 border">&lt;= 100</td>
                            </tr>

                            {/* MICRO */}
                            <tr>
                                <td className="p-4 border font-semibold">Micro Enterprise</td>
                                <td className="p-4 border">-</td>
                                <td className="p-4 border">
                                    P&amp;M / Equipment AND Turnover
                                </td>
                                <td className="p-4 border">&lt;= 2.5</td>
                                <td className="p-4 border">&lt;= 10</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <div className="grid gap-6">
                {sections.map((item, index) => (
                    <div
                        key={index}
                        className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6 my-3 hover:shadow-md transition"
                    >
                        <h2 className="text-2xl font-semibold text-blue-800 mb-3 ">
                            {item.title}
                        </h2>

                        <p className="text-gray-700 leading-7">
                            {item.desc}
                        </p>
                    </div>
                ))}
            </div>


        </div>
    );
}